import { Observable } from 'rxjs';
import { BaseHttpService } from '@core/http/base-http.service';
import { Config } from '@shared/configs/config';
import { EventEmitter, Injectable } from '@angular/core';
import {
  ProjectSiteDiaryDetails,
  ProjectSiteDiaryEntry
} from '@modules/projects/shared/interfaces/project-site-diary.interface';

@Injectable({ providedIn: 'root' })
export class ProjectSiteDiaryDetailService extends BaseHttpService {
  readonly entryChanged = new EventEmitter<{ action: 'delete' | 'update'; id: number }>();

  getDiary(id: number): Observable<ProjectSiteDiaryDetails> {
    return this.get<ProjectSiteDiaryDetails>(`${Config.API}/project-site-diary/${id}`);
  }

  getEntry(id: number): Observable<ProjectSiteDiaryEntry> {
    return this.get<ProjectSiteDiaryEntry>(`${Config.API}/project-site-diary/entry/${id}`);
  }

  getTaskDocumentation(taskId: number): Observable<ProjectSiteDiaryEntry | null> {
    return this.get<ProjectSiteDiaryEntry>(`${Config.API}/project-site-diary/task/${taskId}`);
  }

  updateTaskDocumentation(
    taskId: number,
    payload: { description?: string | null; attachmentPacketIds?: number[] }
  ): Observable<ProjectSiteDiaryEntry> {
    return this.patch(`${Config.API}/project-site-diary/task/${taskId}`, payload);
  }

  updateEntryDescription(id: number, description: string): Observable<ProjectSiteDiaryEntry> {
    return this.patch(`${Config.API}/project-site-diary/entry/${id}`, { description });
  }

  deleteEntry(id: number): Observable<unknown> {
    return this.delete(`${Config.API}/project-site-diary/entry/${id}`);
  }

  deleteDiary(id: number): Observable<unknown> {
    return this.delete(`${Config.API}/project-site-diary/${id}`);
  }
}
